/// <amd-module name="Pipeline/Analytics/PipelineStepsDurationCard/Actions/PipelineStepsDurationCardActionsCreator" />
import { IReportContext } from "Analytics/Shared/Common/Types";
import { ITrendChartReportConfiguration } from "Analytics/Shared/TrendChart/Common/Types";
import { IStageMetrics } from "Pipeline/Analytics/Common/Types";
import { PipelineStepsDurationCardActions } from "Pipeline/Analytics/PipelineStepsDurationCard/Actions/PipelineStepsDurationCardActions";
import { PipelineStepsDurationCardSource } from "Pipeline/Analytics/PipelineStepsDurationCard/Sources/PipelineStepsDurationCardSource";
import { IVssPageContext } from "VSS/Platform/Context";

export class PipelineStepsDurationCardActionsCreator {
    private pipelineStepsDurationCardSource: PipelineStepsDurationCardSource;

    constructor(private actions: PipelineStepsDurationCardActions, private pageContext: IVssPageContext) {
        this.pipelineStepsDurationCardSource = new PipelineStepsDurationCardSource(pageContext);
    }

    public updateConfigurationValues(reportContext: IReportContext, newConfValues: ITrendChartReportConfiguration): Promise<void> {
        this.actions.updateConfigurationValuesAction.invoke(newConfValues);
        return Promise.all([
            this.pipelineStepsDurationCardSource.queryPipelineStepDurationTrendData(reportContext, newConfValues),
            this.pipelineStepsDurationCardSource.queryTopStepDurationData(reportContext, newConfValues)
        ])
        .then((values) => {
            this.actions.updateDataAction.invoke(values[0]);
            this.actions.updateTopStepsDurationDataAction.invoke(values[1]);
        })
        .catch((error) => {
            this.actions.onError.invoke(error);
            return Promise.reject(error);
        })
    }

    public selectStage(selectedStage: IStageMetrics): void {
        this.actions.selectStageAction.invoke(selectedStage);
    }
}
